import { ErrorLayout as Layout } from '../../../layouts/Error/ErrorLayout';

export const TokenExpiredPage = () => {
  return (
    <Layout>
      <h1>Secure Link Expired</h1>
      <p>Please contact BMI to generate a new secure link.</p>
    </Layout>
  );
};
